import classnames from 'classnames'
import { type FC, type ReactNode } from 'react'
import { type IIconsVector, Icon } from 'shared/ui/Icon'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IActionSectionProps = {
  type: 'qualified' | 'disqualified'
  label: ReactNode
  desc: ReactNode
  icon: IIconsVector
  content?: ReactNode
}

export const ActionSection: FC<IActionSectionProps> = ({ type, label, desc, icon, content }) => {
  return (
    <div
      className={classnames(styles.wrap, {
        [styles.qualified]: type === 'qualified',
        [styles.disqualified]: type === 'disqualified',
      })}
    >
      <div className={styles.label}>
        <div className={styles.label__box}>
          <Icon
            icon={icon}
            className={classnames(styles.label__icon, {
              [styles.qualified]: type === 'qualified',
              [styles.disqualified]: type === 'disqualified',
            })}
          />
          <Typography
            tag={'div'}
            variant={'body-lg-medium'}
            color={'var(--content-primary-primary)'}
            ariaLabel={'ActionSection_label'}
          >
            {label}
          </Typography>
        </div>
      </div>

      <div
        className={classnames(styles.section, {
          [styles.qualified]: type === 'qualified',
          [styles.disqualified]: type === 'disqualified',
        })}
      >
        <Typography
          tag={'div'}
          className={styles.label__description}
          variant={'body-md-regular'}
          color={'var(--content-primary-tertiary)'}
          ariaLabel={'ActionSection_description'}
        >
          {desc}
        </Typography>
        {content}
      </div>
    </div>
  )
}
